import { Component, EventEmitter, OnDestroy, OnInit, Input, Output, ViewChild } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { SubSink } from 'subsink2';
import { bl_fi_generic_doc_hdr_RowClass, GenericDocLineDraftLockSerialNumberService, InvSerialNumberService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { PaginationComponent } from '../../../utilities/pagination/pagination.component';
import { pageFiltering, pageSorting } from '../../../listing.utils';
import { withLatestFrom } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SerialNumberStatus } from '../../../models/serial-number.model';
import { Store } from '@ngrx/store';
import { SessionSelectors } from '../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../modules/session/session-controller/states';

@Component({
  selector: 'app-util-serial-number-listing',
  templateUrl: './serial-number-listing.component.html',
  styleUrls: ['./serial-number-listing.component.scss'],
  providers: [ComponentStore]
})
export class SerialNumberListingComponent implements OnInit, OnDestroy {
  @Input() location;
  @Input() serverDocType;
  @Input() postingStatus;
  @Input() draft$: Observable<bl_fi_generic_doc_hdr_RowClass>;
  @Input() invItem$: Observable<any>;
  @Input() serialNumbers: any[];
  @Output() serialNumber = new EventEmitter<any[]>();
  newList: any[] = [];
  private subs = new SubSink();

  gridApi;
  rowData = [];
  invItemGuid: string;
  locationGuid: string;
  existingSerialNumbers: string[];
  checkLock = false;
  @ViewChild(PaginationComponent) paginationComp: PaginationComponent;

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {suppressFilterButton: true},
    minWidth: 200,
    flex: 2,
    sortable: true,
    resizable: true,
    suppressCsvExport: true
  };

  columnsDefs = [
    { headerName: 'SN ID', field: 'sn_id', cellStyle: () => ({ 'text-align': 'left' }), checkboxSelection: true, floatingFilter: true },
    { headerName: 'SN Type', field: 'sn_type', cellStyle: () => ({ 'text-align': 'left' }), floatingFilter: true },
    { headerName: 'SN Description', field: 'sn_description', cellStyle: () => ({ 'text-align': 'left' }), floatingFilter: true },
  ];

  constructor(
    private sessionStore: Store<SessionStates>,
    private snService: InvSerialNumberService,
    private draftLockSNService: GenericDocLineDraftLockSerialNumberService
  ) {}

  ngOnInit() {}

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    
    // refactor
    // handle serial item without inv item guid?
    if (this.draft$) {
      this.subs.sink = this.invItem$.pipe(
        withLatestFrom(this.draft$)
      ).subscribe(([inv, draft]) => {
        if (inv) {
          this.invItemGuid = inv;
        }
        if (draft && draft.guid_store) {
          this.locationGuid = draft.delivery_location_guid ? draft.delivery_location_guid.toString() : draft.guid_store.toString();
          this.setGridData();
        } 
      });
    } else {
      this.subs.sink = this.invItem$.subscribe(inv=>{
        console.error('Draft$ is not defined');
        console.log('inv',inv);
        console.log('this.location',this.location);
        if (inv) {
          this.invItemGuid = inv;
        }
        if (this.location) {
          this.locationGuid = this.location;
          this.setGridData();
        }
      })
    }
    
    
    
    this.subs.sink = this.sessionStore.select(SessionSelectors.selectMasterSettings).subscribe(s=>{
      this.checkLock = s?.ENABLE_DRAFT_LOCK_SERIAL_NUMBER_CHECKING
    })
  }

  setGridData() {
    if(this.invItemGuid && this.locationGuid){
      let page = new Pagination();
      page.limit = 5000
      page.conditionalCriteria = [
        { columnName: 'hdr_item_guid', operator: '=', value: this.invItemGuid },
        { columnName: 'location_guid', operator: '=', value: this.locationGuid },
        { columnName: 'quantity_balance_greater_than', operator: '=', value: '0' }
      ];
      this.subs.sink = this.snService.getByCriteria(page, AppConfig.apiVisa).subscribe(
        { next: (resolve: any) => {
          let snListing = resolve.data;
          if(this.serialNumbers && this.serialNumbers.length>0){
            snListing = resolve.data.filter(existing => !this.serialNumbers.find(sel => (existing.bl_inv_serial_number_hdr.sn_id === sel.sn_id) ))
          }

          const data = snListing.map(serial => serial.bl_inv_serial_number_hdr);
 
          if (this.checkLock) {
            this.getDraftLockSerial(data);
          } else {
            this.setRowData(data);
          }

        }}
      );
    }
  }

  getDraftLockSerial(data) {
    
    let page = new Pagination();
      page.limit = 5000
      page.conditionalCriteria = [
        { columnName: 'inv_item_guid', operator: '=', value: this.invItemGuid },
        { columnName: 'location_guid', operator: '=', value: this.locationGuid },
        { columnName: 'server_doc_types', operator: '=', value: this.serverDocType }
      ];
    this.subs.sink = this.draftLockSNService.getByCriteria(page, AppConfig.apiVisa).subscribe({
      next: (res: any) => {
        res.data.forEach(lock => {
          data = data.filter(item => item.sn_id !== lock.bl_fi_generic_doc_line_draft_lock_serial_number.sn_id);
        });
        this.setRowData(data);
      }
    });
  }

  setRowData(data) {
    const totalRecords = data.length;
    this.rowData = data;
    this.gridApi.setRowData(this.rowData);
  }

  onAdd() {
    const selected = this.gridApi.getSelectedNodes();
    console.log('selected',selected)
    this.newList = []
    if(selected.length>0){
      selected.map(s=>this.mapToSerialNumberObject(s.data.sn_id));
    }
    
    if(this.newList.length>0){
      this.serialNumber.emit(this.newList);
    }
    this.setGridData();
  }

  mapToSerialNumberObject(sn: string){
    console.log('mapToSerialNumberObject',sn)
    const snObj = new SerialNumberStatus();
    snObj.sn_id = sn;
    snObj.status = "VALIDATION_IN_PROGRESS";
    this.newList.push(snObj);
  }

  disableAdd(){
    return this.postingStatus==="FINAL"
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}

/** To create dummy data
            let temp = {
              app_id: null,
              comp_guid: "a82c0c35-92be-43e2-9e98-06500cb8f2f1",
              guid: "585eff44-8767-47fc-bf63-126a82d037c5",
              item_code: "SERIAL-ITEM",
              item_guid: "af841ed8-278e-bc07-29c7-527730ce5005",
              location_guid: "f66ed26b-62b3-53f7-0923-5e7734c04f2f",
              namespace: null,
              quantity_balance: 9,
              quantity_base: 1,
              revision: "c4417fd0-98ba-41f2-9daa-b0eecca90e7b",
              sn_description: null,
              sn_id: "SN5006",
              sn_option_json: null,
              sn_property_json: null,
              sn_type: "predefined",
              status: "ACTIVE",
              vrsn: null,
            }
          
            for (let i=0; i<500; i++){
              temp.sn_id = temp.sn_id + (i+1).toLocaleString()
              this.rowDataClient.push(temp)
            }
            console.log(this.rowDataClient)
*/